<template>
<div :class="`odr-wrap odr-wrap_borders_border-color-${borderColor}
                odr-wrap_background-color-${color}
                ${borderRadius === 'none' ? '' : `odr-wrap_border-radius-${borderRadius}`}
                ${paddings === 'true' ? '' : 'odr-wrap_no-paddings'}
                ${inline === 'false' ? '' : 'odr-wrap_inline'}
                ${margins === 'false' ? '' : 'odr-wrap_margins'}
                ${shadow === 'false' ? '' : 'odr-wrap_shadow'}
                ${borders === 'false' ? '' : 'odr-wrap_borders'}
                ${bordersVertical === 'false' ? '' : 'odr-wrap_borders_vertical'}
                ${borders === 'true' && solidBorders === 'true' ? 'odr-wrap_solid-borders' : ''}
                ${bordersVertical === 'true' && solidBorders === 'true' ? 'odr-wrap_solid-borders_vertical' : ''}`">
    <slot> </slot>
</div>
</template>

<script>
import { availableColors, coloringMixin } from '../mixins/coloring'
import '../styles/wrap.scss'

export default {
    mixins: [coloringMixin],
    props: {
        borderRadius: {
            _descr: 'border radius: half|single|double|none',
            default: 'none',
            type: String,
        },
        inline: {
            default: 'false',
            type: String,
            _descr: 'Inline-block behavior',
        },
        paddings: {
            default: 'true',
            type: String,
            _descr: 'Add padding spacings',
        },
        margins: {
            default: 'true',
            type: String,
            _descr: 'Add margin spacings',
        },
        borders: {
            default: 'false',
            type: String,
            _descr: 'Add horizontal borders',
        },
        shadow: {
            default: 'false',
            type: String,
            _descr: 'Add shadow',
        },
        solidBorders: {
            default: 'false',
            type: String,
            _descr: '2px borders borders',
        },
        bordersVertical: {
            default: 'false',
            type: String,
            _descr: 'Add vertical borders',
        },
        borderColor: {
            type: String,
            default: 'default',
            validator: value => availableColors.indexOf(value) !== -1,
            _descr: availableColors.join('|'),
        },
    },
}
</script>
